<template>
  <div class="flex w-full justify-center">
    <div
      class="flex max-w-2xl flex-col items-center justify-start gap-y-11 rounded-md bg-white p-11 shadow-sm transition-all duration-300 hover:shadow-md"
    >
      <div class="flex w-full items-center justify-center">
        <span class="text-center text-3xl font-medium">
          {{ __('Choose how you want to create the job') }}
        </span>
      </div>
      <div class="grid w-full grid-cols-1 gap-8 sm:grid-cols-2">
        <div
          @click.stop="handleScratchClick"
          :class="fromScratchSelected ? 'border-zinc-800' : ''"
          class="flex h-full w-full cursor-pointer flex-col justify-start gap-y-4 rounded-xl border border-gray-200 p-6 shadow-sm transition-shadow duration-300 hover:shadow-md focus:outline focus:outline-2 focus:outline-primary"
        >
          <div class="w-full">
            <Icon
              name="add"
              class="rounded-lg bg-secondary/10 px-2 py-1 !text-2xl"
            ></Icon>
          </div>
          <span class="text-lg font-medium">
            {{ __('Create from Scratch') }}
          </span>
          <span>
            {{ __('Build a job posting without using any template') }}
          </span>
        </div>
        <div
          @click.stop="handleTemplateClick"
          :class="fromTemplateSelected ? 'border-zinc-800' : ''"
          class="flex h-full w-full cursor-pointer flex-col justify-start gap-y-4 rounded-xl border border-gray-200 p-6 shadow-sm transition-shadow duration-300 hover:shadow-md"
        >
          <div class="w-full">
            <Icon
              name="upload_file"
              class="rounded-lg bg-secondary/10 px-2 py-1 !text-2xl"
            ></Icon>
          </div>
          <span class="text-lg font-medium">
            {{ __('Create using Template') }}
          </span>
          <span>
            {{ __('Get started quickly with already designed templates') }}
          </span>
        </div>
      </div>
      <div v-show="fromTemplateSelected" class="w-full">
        <label class="mb-2 block text-sm text-[#58585E]"
          >{{ __('Choose Template') }} *</label
        >
        <FormSingleselect
          v-model="selectedTemplate"
          :placeholder="__('Choose template from the predefined list')"
          :values="templates"
          :clearable="true"
          @clear="selectedTemplate = null"
          type="static"
          :errors="[]"
          required
        />
      </div>

      <div class="flex w-full items-center justify-end gap-x-4">
        <Button class="duration-300" variant="ghost">{{ __('Cancel') }}</Button>
        <Button
          class="flex items-center justify-center gap-x-2 duration-300"
          variant="fill"
          transition="transition-opacity"
          :disabled="
            isLoading ||
            (!fromScratchSelected &&
              (!fromTemplateSelected ||
                (fromTemplateSelected && selectedTemplate === null)))
          "
          @click="
            fromTemplateSelected
              ? $emit('selectedTemplate', { template: selectedTemplate })
              : $emit('selectedFromScratch')
          "
          >{{ __('Next step') }}
          <Icon
            v-if="isLoading"
            class="animate-spin text-lg"
            name="progress_activity"
          ></Icon>
        </Button>
      </div>
    </div>
  </div>
</template>

<script setup="">
  import Button from '@/components/block/button/button.vue';
  import FormSingleselect from '@/components/global/Form/FormSingleselect.vue';

  import Icon from '@/components/global/Icon.vue';

  import { ref } from 'vue';
  import { __ } from '@/helpers';

  const props = defineProps({
    templates: {
      type: Array,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  });

  const selectedTemplate = ref(null);
  const fromTemplateSelected = ref(false);
  const fromScratchSelected = ref(false);
  const handleTemplateClick = () => {
    fromScratchSelected.value = false;
    fromTemplateSelected.value = !fromTemplateSelected.value;
  };
  const handleScratchClick = () => {
    fromTemplateSelected.value = false;
    fromScratchSelected.value = !fromScratchSelected.value;
  };
</script>
